import api from "./api";

export const updateCurrentCustomer = async () => {
  throw new Error(
    "updateCurrentCustomer n'est pas encore disponible côté backend."
  );
};

export const customerLogin = ({ username, email, password }) =>
  api.post("/auth/login/client", { username, email, password });

export const fetchCurrentCustomer = () =>
  api.get("/auth/current_client");

export const fetchCurrentCustomerLoyalty = () =>
  api.get("/auth/current_client/loyalty");

export const fetchCurrentCustomerLoyaltyBenefits = () =>
  api.get("/auth/current_client/loyalty/benefits");

export const fetchCurrentCustomerLoyaltyTransactions = () =>
  api.get("/auth/current_client/loyalty/transactions");

export const forgotCustomerPassword = (payload) =>
  api.post("/auth/forgot-password/client", payload);

export const resetCustomerPassword = (token, payload) =>
  api.post(`/auth/reset-password/client/${encodeURIComponent(token)}`, payload);

export const registerCustomer = (payload) =>
  api.post("/auth/register/client", {
    firstname: payload.firstname?.trim(),
    lastname: payload.lastname?.trim(),
    email: payload.email?.trim().toLowerCase(),
    phone_number: payload.phone_number?.trim(),
    address: payload.address?.trim(),
    postal_code: payload.postal_code?.trim(),
    city: payload.city?.trim(),
    country: payload.country?.trim() || "France",
  });

export const fetchCustomerHistory = async () => ({ data: [] });
export const fetchCustomerPlayerIdentifiers = async () => ({ data: [] });
export const fetchCustomerEvents = async () => ({ data: [] });
